import React from "react";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";

import { SecureContextualMenu } from "@common/secureContextualMenu";
import { useModal } from "@root/client/modal";
import { ProjectElementType } from "@planzone/dto";
import { clip } from "@common/clipeable";
import { Props } from "./types";
import { DatesPickers } from "./datesPickers";
import styles from "./styles.scss";

function Timestamp({ list, error, isMultiProject, readOnly }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();

  return (
    <div className={styles.timestamp}>
      <div className={styles.dates}>
        <DatesPickers
          list={list}
          isInvalid={error.startDateOutOfBound || error.invalidDateRange}
          readOnly={readOnly}
        />
      </div>
      <div className={styles.redirectionsMenu}>
        <div className={styles.contextualMenu}>
          <SecureContextualMenu
            context={{ list }}
            items={[
              {
                name: t("listRetrieval.copyUrl"),
                useCase: UseCases.retrieveList,
                act: () => clip(`${location.origin}/lists/${list.uuid}`, null),
              },
              {
                name: t("listRetrieval.move"),
                useCase: UseCases.moveListElement,
                act: () =>
                  pushView({
                    key: UseCases.moveListElement,
                    data: {
                      projectElementId: list.uuid,
                      projectElementType: ProjectElementType.LIST,
                      currentParentList: list.parentList || list,
                      project: list.project,
                    },
                  }),
              },
              {
                name: t("listRetrieval.remove"),
                useCase: UseCases.removeList,
                act: () =>
                  pushView({
                    key: UseCases.removeList,
                    data: { list },
                  }),
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}

export { Timestamp };
